// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__gZwau","content":"Consent_content__3M1r8","footer":"Consent_footer__7RL3A"};